import { client } from "../../../api/client";

export const fetchModulesList = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
        return require("./_local/_modulesData.json");
    } else {
        try {
          const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/module");

          const modules = response.data.map(module => {
              if (!module.settingsJson || module.settingsJson === "") {
                  module.settings = {};
              } else {
                  module.settings = JSON.parse(module.settingsJson);
              }
              delete module.settingsJson;
              return module;
          });

          return modules.sort((a, b) => a.moduleName.localeCompare(b.moduleName));
        } catch (error) {
            console.error("Error fetching item lookup:", error);
            return [];
        }
      }
}

export const fetchModuleData = async (moduleId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      if (moduleId === 1) {
        return require("./_local/_module_avaya_aura.json")
      } else {
        return require("./_local/_moduleData.json");
      }
    } else {
        try {
          const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/module/" + moduleId);

          const module = response.data;

          if (!module.settingsJson || module.settingsJson === "") {
              module.settings = {};
          } else {
              module.settings = JSON.parse(module.settingsJson);
          }

          delete module.settingsJson;          

          return module;
        } catch (error) {
            console.error("Error fetching item lookup:", error);
            return [];
        }
      }
}

export const setActiveRevision = async (module, activeRevisionNumber) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      var updatedRevisions = module.moduleRevisions.map(x => { return ({...x, disabled: (x.revisionNumber !== activeRevisionNumber)})})
      return { message: "success", moduleRevisions: updatedRevisions }
    } else {
        try {
          const response = await client.put(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/module/" + module.id + "/SetActiveRevisionNumber/" + activeRevisionNumber);
          if (response.ok) {
            return { message: "success" }
          } else {
            return { message: "Error setting active module revision: " + response.data }
          }
        } catch (error) {
            console.error("Error setting active module revision:", error);
            return { message: "error: " + error }
        }
      }
}

export const updateModule = async (module) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", module: module }
    } else {
        try {

          const moduleToSave = { ...module, settingsJson: JSON.stringify(module.settings) };

          const response = await client.put(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/module/" + module.id, moduleToSave);

          return response.data;
        } catch (error) {
            console.error("Error creating module:", error);
            return { message: "error:" + error, module: null }
        }
      }
}


export const createModule = async (module) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", module: {
        ...module, 
          id: Math.floor(Math.random() * 900) + 101, // gives 101 to 1000
          createdAt: Date.now(),
          updatedAt: Date.now(),
          moduleCategory: null,
          supplier: null,
          moduleRevisions: [],
          settings: {}
        } }
    } else {
        try {
          const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/module", module);
          return response.data;
        } catch (error) {
            console.error("Error creating module:", error);
            return { message: "error:" + error, module: null }
        }
      }
}

